// react
import { useContext } from "react";
// libs
import styled from "styled-components";
import { useTitle } from "react-use";
// components
import { Intro } from "../components/intro/Intro";
import Scene from "../components/scene/Scene";
import { LayoutScene } from "../layout/LayoutScene";
import { LoadingScreen } from "../components/LoadingScreen";
// context
import { ShowIntroContext } from "../context/IntroContext";
// hooks
import { useGetArtifacts } from "../hooks/useGetArtifacts";
import { useSetLogoStyle } from "../hooks/useSetLogoStyle";

const MainSection = styled.div`
  position: relative;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.hotPink};
`;

function Home() {
  const { showIntro } = useContext(ShowIntroContext);

  const [isLoaded] = useGetArtifacts();

  useSetLogoStyle("light");

  useTitle("Exhibit home | Boots Exhibition");

  return (
    <LayoutScene>
      <LoadingScreen isLoading={!isLoaded} />
      <Intro showIntro={showIntro && isLoaded} />
      <MainSection>
        <Scene isAnimating={!showIntro} />
      </MainSection>
    </LayoutScene>
  );
}

export default Home;
